import styles from './TraceEventPropertiesView.module.css'

interface TraceEventPropertiesViewProps {
  pageName?: string
  properties?: Map<string, string>
}

export default function TraceEventPropertiesView(props: TraceEventPropertiesViewProps) {
  const propertyRows = []
  for (const [key, value] of props.properties?.entries() || []) {
    propertyRows.push(
      <tr key={key}>
        <th>{key}</th>
        <td>{value}</td>
      </tr>
    )
  }

  return (
    <div className={styles.eventDetail}>
      <header>
        <h1>Properties on Page TraceEvent [{props.pageName}]</h1>
      </header>
      <main>
        <div>
          <h2>Properties on Page {props.pageName}</h2>
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody>{propertyRows}</tbody>
          </table>
        </div>
      </main>
    </div>
  )
}
